import { UNREAD_MSG } from '../constants/constants';

const initialState = {
  unreadMessage: false,
};

const unreadReducer = (state = initialState, action = {}) => {
  const { payload = {} } = action;
  if (action.type === UNREAD_MSG)
    return {
      ...state,
      ...payload,
    };
  else return state;
};

export default unreadReducer;
